export default __webpack_public_path__ + "static/media/certificate.cffb9cf0.png";